import EventApi from "../api/EventsApi";

export default class KeyboardEventsObserver {
    constructor() {
        this.bindEvents();
    }

    /**
     * Обработка нажатия пробела
     * @param e
     * @private
     */
    private pressSpaceEvent(e: any): void
    {
        const pixiScene = window.PixiScene;
        const keySpaceCode = 'Space';
        if (e.code === keySpaceCode) {
            if (typeof pixiScene !== 'undefined') {
                let hoverSrc = pixiScene.getHoverSrc();
                if (hoverSrc && hoverSrc.length && typeof hoverSrc[0] !== 'undefined' && hoverSrc[0]) {
                    EventApi.triggerEvent(EventApi.ZOOM_ITEMS, hoverSrc);
                }
            }
        }
    }

    /**
     * Обработка нажатия пробела
     * @param e
     * @private
     */
    private pressTildaEvent(e: any): void
    {
        const keyTildaCode = 'Backquote';
        if (e.code === keyTildaCode) {
            EventApi.triggerEvent(EventApi.TOGGLE_FPS_COUNTER);
        }
    }

    private bindEvents(): void
    {
        document.addEventListener('keyup', this.pressSpaceEvent.bind(this));
        document.addEventListener('keyup', this.pressTildaEvent.bind(this));
    }
}
